/*
* Contains helper functions for dealing with FlowPlayer and streaming flash videos
*/

FlowPlayerHelper = new Class({
    Binds: ["getDuration"],

    Implements: Options,

    // Default (video) options
    options: {
        clip: {
            // Don't play immediately
            autoPlay: false,
            // Start buffering immediately
            autoBuffering: true,
            // Streaming plugin, defined below
            provider: "pseudostreamer",
            // Scale videos to fit the container
            scaling: "fit"
        },
        plugins: {
            pseudostreamer: {
                url: Librarian.path.getLayoutsPath() + "flowplayer/flowplayer.pseudostreaming-3.2.13.swf"
            },
            audio: {
                url: Librarian.path.getLayoutsPath() + "flowplayer/flowplayer.audio-3.2.10.swf"
            }
        },
        key: (window.location.href.contains("accent-technologies.com") ?
            // accent-technologies.com
            "#$46d9ffcf2c2184baf4e" :
            // presentation-librarian.com
            "#$40e28f4b437a11d9d2f")
    },

    // Audio option overrides
    audioOptions: {
        clip: {
            provider: "audio",
            autoBuffering: false
        },
        plugins: {
            controls: {
                fullscreen: false,
                autoHide: false
            }
        }
    },

    flowplayerObj: null,

    initialize: function(playerId, url, audio, options) {
        if (audio) 
            this.setOptions(this.audioOptions);

        this.setOptions(options);

        // Workaround to completely remove provider option if set to null
        if (!this.options.clip.provider)
            delete this.options.clip.provider;

        var player = $(playerId);
        if (player) {
            // Ampersands must be url encoded for flowplayer
            url = url.replaceAll('&', '%26');

            this.options.clip.url = url;
            this.flowplayerObj = flowplayer(player, { src: Librarian.path.getLayoutsPath() + "flowplayer/flowplayer.commercial-3.2.15.swf", wmode: "opaque" }, this.options);

            // Add getDuration function
            this.flowplayerObj.getDuration = this.getDuration;
        }
    },

    getDuration: function() {
        return this.flowplayerObj.getClip().fullDuration;
    }
});

/* Static functions */
FlowPlayerHelper.extend({
    loadVideo: function(playerId, fileName, options) {
        var url = Librarian.path.videoStreamingUrl + fileName,
            helper = new FlowPlayerHelper(playerId, url, false, options);
        return helper.flowplayerObj;
    },

    loadAudio: function(playerId, url, options) {
        // Determine audio provider automatically based on file type
        // This is because only MP3s work with the audio plugin.
        // However, some audio files (e.g. M4A) can be played with the default video provider
        if (options.data) {
            var fileName = options.data.name;

            if (!options.clip)
                options.clip = {};

            options.clip.provider = (fileName && fileName.endsWith(".mp3")) ? "audio" : null;
        }

        var helper = new FlowPlayerHelper(playerId, url, true, options);
        return helper.flowplayerObj;
    }
});

